/**
 * Cookie Plugin Landing Page
 */

import './cookie-plugin.css';

// Import shared utilities
import '../shared/topbar.js';
import '../shared/coupon.js';
import '../shared/mobile-menu.js';
import '../shared/mega-menu.js';

// Import landing page modules
import '../shared/landing/hero.js';
import '../shared/landing/animations.js';

// Import FAQ accordion
import '../shared/faq.js';

// Import and initialize subscription form
import { initPluginSubscribe } from '../shared/subscribe.js';
initPluginSubscribe();

console.log('Cookie Plugin page loaded (Edge/Vite bundle)');
